import { OdataManager } from '@/api/odata/odata-manager';
import { Contract } from '@/api/model/interfaces';

export default class ContractOdata extends OdataManager<Contract> {}
